/**
 * @directive sg-drag-and-drop-lists
 * requires $scope.lists to be present on parent scope TODO Fix this, very bad practice
 * @param $scope.lists {Array} - array of objects each representing a list
 * @param $scope.lists.items {Array} - array of objects each representing an item in the list
 * @param $scope.lists.label {String} - title of the list
 * @param $scope.lists.itemLabelKey {String} - key to determine the label of each item. Defaults to 'name'
 * @param $scope.lists.drop {Function} - callback function when an item is dropped in this list. is called
 *                                with a single argument: {index, item}
 *                                  1. this function should return false if the drop is rejected
 *                                  2. this function should return true if the controller will update the list
 *                                  3. this function should return any other truthy value if the list
 *                                  should be updated automatically
 * @param [$scope.lists.moved] {Function} - Optional callback to be called when an item has been moved.
 *                                          Defaults to splicing the item from the list
 * @param [$scope.lists.id] {String} - Optional id to place on the md-list component
 *
 * */

(function () {
  angular
    .module('specsguardApp')
    .directive('sgDragAndDropLists', sgDragAndDropLists);

  function sgDragAndDropLists () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-drag-and-drop-lists/sg-drag-and-drop-lists.html',
    };
  }
})();
